import { MY_SUBSCRIPTIONS_RECEIVE } from "../constants";

export const receive = (data) => ({
    type: MY_SUBSCRIPTIONS_RECEIVE,
    payload: data,
});